import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import VisitsTable from "@/components/portal/VisitsTable";
import { PageHeader, Spinner, STATUS } from "@/components/portal/ui";

const SCOPES = [
  { key: "upcoming", label: "Prossime" },
  { key: "past", label: "Passate" },
  { key: "all", label: "Tutte" },
];

export default function MyVisitsPage() {
  const { user } = useAuth();
  const [visits, setVisits] = useState(null);
  const [scope, setScope] = useState("upcoming");
  const isDoctor = user.role === "doctor";

  const load = useCallback(() => {
    const today = new Date().toISOString().slice(0, 10);
    const params = {};
    if (scope === "upcoming") params.date_from = today;
    if (scope === "past") params.date_to = today;
    api.get("/visits", { params }).then((r) => setVisits(scope === "past" ? [...r.data].reverse() : r.data)).catch((e) => toast.error(apiError(e)));
  }, [scope]);

  useEffect(() => {
    load();
  }, [load]);

  const changeStatus = async (v, status) => {
    try {
      await api.put(`/visits/${v.id}`, { status });
      toast.success(`Visita ${STATUS[status].label.toLowerCase()}`);
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <div data-testid="my-visits">
      <PageHeader eyebrow="Visite" title="Le mie visite" desc={isDoctor ? "Le visite assegnate a te. Segna come completate quelle effettuate." : "Le visite a domicilio a cui sei stato assegnato."} />
      <div className="mb-5 inline-flex rounded-full bg-white p-1 ring-1 ring-[#5B2C91]/10" data-testid="my-visits-scope-tabs">
        {SCOPES.map((s) => (
          <button key={s.key} onClick={() => setScope(s.key)} className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${scope === s.key ? "bg-[#5B2C91] text-white" : "text-[#4A4059] hover:text-[#5B2C91]"}`} data-testid={`my-visits-scope-${s.key}`}>
            {s.label}
          </button>
        ))}
      </div>
      {visits === null ? (
        <div className="flex justify-center py-16"><Spinner /></div>
      ) : (
        <VisitsTable visits={visits} role={user.role} onStatus={isDoctor ? changeStatus : undefined} emptyTitle="Nessuna visita" emptyDesc={isDoctor ? "Quando l'amministrazione ti assegnerà una visita la vedrai qui." : "Quando verrai assegnato a una visita la vedrai qui."} />
      )}
    </div>
  );
}
